import { combine, withCallbacks, withContext } from 'react-hooks-combine'
import { spec, validators } from 'utils/validation'
import { withFormModel } from 'shared/hooks'
import { StoreContext } from 'store/context'
import { ServicesContext } from 'services/context'

import BeneficiaryFormComponent from './component'

const { string, any } = validators

export default combine(
  withContext('appStore', StoreContext),

  withContext(
    'jurisdictionsService',
    ServicesContext,
    ({ jurisdictionsService }) => jurisdictionsService
  ),

  withFormModel(
    {
      beneficiaryName: {
        initialValue: '',
        alias: 'Beneficiary Name',
        spec: spec.flow(string.isString, string.isNotEmpty, any.required),
      },

      contactFirstName: {
        initialValue: '',
        alias: 'Contact First Name',
        spec: spec.flow(string.isString, string.isNotEmpty, any.required),
      },

      contactLastName: {
        initialValue: '',
        alias: 'Contact Last Name',
        spec: spec.flow(string.isString, string.isNotEmpty, any.required),
      },

      address1: {
        alias: 'address1',
        spec: spec.flow(string.isString),
      },
      address2: {
        alias: 'address2',
        spec: spec.flow(string.isString),
      },
      city: {
        alias: 'city',
        spec: spec.flow(string.isString),
      },
      state: {
        alias: 'state',
        spec: spec.flow(string.isString),
      },
      zip: {
        alias: 'zip',
        spec: spec.flow(string.isString),
      },
      country: {
        alias: 'country',
        spec: spec.flow(),
      },

      email: spec.flow(
        string.isString,
        string.isEmail,
        string.isNotEmpty,
        any.required
      ),

      website: {
        initialValue: '',
        spec: spec.flow(string.isString, string.isNotEmpty, any.required),
      },
    },
    { id: 'pre-registration-form' }
  ),

  withCallbacks(
    {
      getOptionLabel:
        () =>
        ({ name }) =>
          name,
      getOptionValue:
        () =>
        ({ id }) =>
          id,

      loadJurisdictions:
        ({ jurisdictionsService }) =>
        (search = '') =>
          jurisdictionsService.getJurisdictionsPublic({ search }),

      onSubmitForm:
        (_state, { onSubmit }) =>
        (entity) => {
          const mapToServerFormat = () => {
            const {
              address1,
              address2,
              zip,
              country,
              state,
              city,
              contactFirstName,
              contactLastName,
              email,
              beneficiaryName,
              website,
              taxId,
            } = entity

            return {
              beneficiaryName,
              contactFirstName,
              contactLastName,
              email,
              website,
              taxId,
              address: {
                address1,
                address2,
                zip,
                country: country.name ?? '',
                state,
                city,
              },
            }
          }
          return onSubmit(mapToServerFormat())
        },
    },
    []
  )
)(BeneficiaryFormComponent)
